import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Store } from '@ngrx/store';
import { Decimal } from 'decimal.js';
import { Observable, combineLatest, map } from 'rxjs';

import { betslipSelector } from '../../../../base/store/selectors';
import { BetslipGeneratorContextType } from '../../../bet-generation/models';
import { BetslipSummaryService } from '../../../summary/services/betslip-summary.service';
import { selectQuickBetContext, selectQuickBetErrorsStateWithRewardsTokens } from '../../quick-bet.selectors';
import { QuickBetUtils } from '../../services/quick-bet-utils.service';

@Component({
    selector: 'bs-quick-bet-taxation-liability',
    templateUrl: './quick-bet-taxation-liability.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-taxation-liability.component.scss'],
    standalone: false,
})
export class QuickBetTaxationLiabilityComponent {
    taxationLiability$: Observable<Decimal | null>;

    constructor(quickBetUtils: QuickBetUtils, summaryService: BetslipSummaryService, store: Store) {
        const summary$ = summaryService.getSummaryViewModel(BetslipGeneratorContextType.Betslip);
        const betslipState$ = store.select(betslipSelector);
        const errorsStatus$ = store.select(selectQuickBetErrorsStateWithRewardsTokens);
        const rewardTokenContext$ = store.select(selectQuickBetContext);

        this.taxationLiability$ = combineLatest([summary$, betslipState$, errorsStatus$, rewardTokenContext$]).pipe(
            map(([summary, state, errorsStatus, rewardTokenContext]) =>
                quickBetUtils.getActionButtonState([summary.betslip, summary.summary], state, errorsStatus, rewardTokenContext),
            ),
            map((actionButtonState) => (actionButtonState.taxationLiability?.greaterThan(0) ? actionButtonState.taxationLiability : null)),
        );
    }
}
